import React, { useEffect, useState } from 'react';
import StockMetricTable from './StockMetricTable';

const HomeComponent = () => {
 //http://192.168.1.156:8080/stockmetrics?index=russell_2000&date=2023-12-10

  const[data, setData] = useState([]);

  useEffect(() => {
    const fetchStockMetrics = async () => {
        try {
	    console.log(process.env.NODE_ENV);
            console.log("fetching stock metrics data");
            const url = process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_STOCK_SERVICE_DEV : "";
            const response = await fetch(url + '/stockmetrics');
            console.log("response:", response);
            const result = await response.json();
            console.log("result:", result);
            setData(result);

        } catch (error) {
            console.error("Error fetch stock metrics. ", error);
        }
    };

    fetchStockMetrics();
  }, []);

  const columns = [
    {
      Header: 'ticker',
      accessor: 'ticker', // accessor is the "key" in the data
    },
    {
      Header: 'indexName',
      accessor: 'indexName',
    },
    {
    Header: 'Sector',
    accessor: 'sector',
    },
    {
    Header: 'Industry',
    accessor: 'industry',
    },
    {
      Header: 'updateDate',
      accessor: 'updateDate',
    },
    {
      Header: 'dividendYield',
      accessor: 'dividendYield',
    },
    {
      Header: 'pbRatio',
      accessor: 'pbRatio',
    },
    {
      Header: 'peRatio',
      accessor: 'peRatio',
    },
  ];

  return (
        <React.Fragment>
            <div>
                <h1>Stock Metric Table</h1>
                <StockMetricTable columns={columns} data={data}></StockMetricTable>
            </div>
        </React.Fragment>
    );
};

export default HomeComponent;
